import { Injectable } from "@angular/core";
import { MissingTranslationHandler, MissingTranslationHandlerParams } from "@ngx-translate/core";
import * as englishTemplate from "./english-template.json";

const warnedKeys = new Set<string>();

@Injectable()
export class TemplateMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    const value = params.key.split(".").reduce<unknown>((obj, part) => {
      return obj && typeof obj === "object" ? (obj as Record<string, unknown>)[part] : undefined;
    }, englishTemplate as unknown);

    if (typeof value === "string") {
      if (params.interpolateParams) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (params.translateService as any).parser.interpolate(value, params.interpolateParams) as string;
      }
      return value;
    }

    if (!warnedKeys.has(params.key)) {
      warnedKeys.add(params.key);
      console.warn(`Missing translation for key: "${params.key}"`);
    }
    return params.key;
  }
}
